import React from "react"
import styles from "./tabs.module.css"
import { useFaceTabsViewModel, type FaceTabItem } from "./FaceTabs.vm"

export type { FaceTabItem }

type FaceTabsProps = {
  tabs: FaceTabItem[]
  activeIndex?: number
  onActiveIndexChange?: (index: number) => void
  className?: string
  fullWidth?: boolean
  ariaLabel?: string
}

export const FaceTabs = ({
  tabs,
  activeIndex = 0,
  onActiveIndexChange,
  className = "",
  fullWidth = false,
  ariaLabel = "Insert faces",
}: FaceTabsProps) => {
  const { currentIndex, handleClick, handleKeyDown, getTabId, getPanelId } = useFaceTabsViewModel({
    tabs,
    activeIndex,
    onActiveIndexChange,
  })

  if (tabs.length === 0) {
    return null
  }

  return (
    <div
      className={`${styles["face-tabs"]} ${fullWidth ? styles["face-tabs--full-width"] : ""} ${className}`}
    >
      <div
        className={`${styles["face-tabs__list"]} ${fullWidth ? styles["face-tabs__list--full-width"] : ""}`}
        role="tablist"
        aria-label={ariaLabel}
      >
        {tabs.map((tab, index) => (
          <button
            key={tab.id}
            id={getTabId(index)}
            type="button"
            className={`${styles["face-tabs__tab"]} ${index === currentIndex ? styles["face-tabs__tab--active"] : ""} ${fullWidth ? styles["face-tabs__tab--full-width"] : ""}`}
            role="tab"
            aria-selected={index === currentIndex}
            aria-controls={getPanelId(index)}
            tabIndex={index === currentIndex ? 0 : -1}
            onClick={() => handleClick(index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  )
}
